import {
    FETCH_CONTENTS_REQUESTED,
    FETCH_CONTENTS_SUCCESS,
    FETCH_CONTENTS_SEARCH_REQUESTED,
    FETCH_CONTENTS_SEARCH_SUCCESS,
    GENERATE_SRT_REQUESTED,
    GENERATE_SRT_SUCCESS,
    GENERATE_SRT_FAILURE,
    PING_SRT_REQUESTED,
    PING_SRT_SUCCESS,
    PING_SRT_FAILURE
} from "../actionTypes"
  
const initialState = {
    contents : [],
    isSearchResults : false,
    isLoading : false,
    isSRTLoading : false,
    isFetchingMore : false,
    next_page_token : null,
    isSRTFailure : false,
    srtUniqueId : null,
    srtUrl : null,
    currentAudioTitle : "Press play to listen to this."
};
  
export default function ContentReducer(state = initialState, action) {
    const { type } = action;
  
    switch (type) {

      case FETCH_CONTENTS_REQUESTED:
        let isLoading = true
        let isFetchingMore = false

        if(action.payload.filter.isMore){
          isLoading = false
          isFetchingMore = true
        }
        return {
          ...state,
          isLoading,
          isFetchingMore
        };

      case FETCH_CONTENTS_SEARCH_REQUESTED:

        return {
          ...state,
          isLoading : true,
        };
  
      case FETCH_CONTENTS_SUCCESS:
        let contents = action.payload.contents
        
        if(action.payload.filter && action.payload.filter.isMore){
          contents = [...state.contents, ...contents]
        }
        let newState = {
          ...state,
          contents,
          isLoading : false,
          isFetchingMore : false,
          isSearchResults : false
        };

        newState["nextPageToken"] = action.payload.nextPageToken

        return newState

      case FETCH_CONTENTS_SEARCH_SUCCESS:

        return {
          ...state,
          contents : action.payload.contents,
          isLoading : false,
          isFetchingMore : false,
          isSearchResults : true
        };

      case GENERATE_SRT_REQUESTED:
        return {
          ...state,
          isSRTLoading : true,
          srtUrl : null
        }

      case GENERATE_SRT_SUCCESS:
        return {
          ...state,
          srtUniqueId : action.payload.srtUniqueId 
        }

      case GENERATE_SRT_FAILURE:
        return {
          ...state,
          isSRTLoading : false,
          srtUrl : null
        }

      case PING_SRT_REQUESTED:
        return {
          ...state,
          isSRTLoading : true,
          srtUrl : null,
          isSRTFailure : false
        }

      case PING_SRT_SUCCESS:
        return {
          ...state,
          isSRTLoading : false,
          srtUrl : action.payload.url,
        }

      case PING_SRT_FAILURE:
        return {
          ...state,
          isSRTLoading : false,
          srtUrl : null,
          isSRTFailure : true
        }
  
      default:
        return state;
    }
}
  